import styled from 'styled-components';

export const Container = styled.div`
  width: 100%;
  min-height: 98px;

  &.background {
    background-color: var(--color-white-primary);
    padding: 24px 32px;
  }
  &.fixed {
    position: fixed;
    bottom: 0;
    padding: 24px;
    /* iOS Chrome does not always expose env(safe-area-inset-bottom); use 34px as
       a safe minimum that covers the home-indicator area on modern iPhones */
    padding-bottom: max(34px, env(safe-area-inset-bottom, 34px));
    max-width: var(--app-max-width, 100%);
    left: 50%;
    transform: translateX(-50%);
    background-color: var(--color-white-primary);
  }
`;

export const ContainerButton = styled.div`
  width: 100%;
  flex-direction: column;

  > button {
    width: 100%;
  }
  > button:last-child {
    margin-left: 0px !important;
    margin-top: 8px;
  }
`;
